/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

/**
 * Creates the product features section
 *
 * Usage example:
 * <product-features
 * data-features="features" data-summary-limit="10">
 * </product-features>
 * Features object example :
 * var product = [{
 *     "name": 'Energy Rating',
 *     "value": "A+++"
 * }, {
 *     "name": 'Delay Start',
 *     "value": "Yes"
 * }, {
 *     "name": 'Max. Spin Speed',
 *     "value": "1400rpm"
 * }, {
 *     "name": 'Energy Rating',
 *     "value": "A+++"
 * }, {
 *     "name": 'Energy Rating',
 *     "value": "A+++"
 * }]
 *
 */
function productFeaturesDirective() {
    return {
        restrict: 'E',
        scope: {
            features: '=',
            summaryLimit: '=',
            featuresDescription: '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: productFeaturesController,
        template: require('./productFeaturesView.html')
    };
}

productFeaturesController.$inject = [
    '$scope',
    'ProductService',
];
function productFeaturesController (
    $scope,
    ProductService
) {
    
    this.$onInit = function () {

        let vm = this;
        var _summaryLimit = parseInt(vm.summaryLimit);

        vm.showSeeMoreSection = (vm.features.length > _summaryLimit);

        var _allProductFeatures = vm.features;
        var _summaryProductFeatures = _allProductFeatures.slice(0, _summaryLimit);

        vm.productFeatures = _summaryProductFeatures;

        vm.productDescriptionEnabled = ProductService.getDetailsPageConfig('product_description_enabled');

        $scope.$watch('vm.featuresDescription', function () {
            if (vm.productDescriptionEnabled) {
                vm.productDescription = vm.featuresDescription;
            }
        });

        vm.isProductFeaturesSummary = true;

        vm.expandCollapseProductFeatures = function () {

            if (vm.isProductFeaturesSummary) {

                vm.productFeatures = _allProductFeatures;
                vm.isProductFeaturesSummary = false;

            } else {

                vm.productFeatures = _summaryProductFeatures;
                vm.isProductFeaturesSummary = true;

            }

        };

    }
}

module.exports = productFeaturesDirective;
